import React from 'react';
import { Clock, AlertTriangle, Moon } from 'lucide-react';

const TimingStrategy = ({ strategy }) => {
  if (!strategy || strategy.length === 0) return null;

  return (
    <div className="timing-strategy-card">
      <div className="timing-header">
        <Clock className="timing-icon" size={20} />
        <h3>Estratègia de Temps i Seguretat</h3>
      </div>
      <div className="timing-list">
        {strategy.map((item, index) => {
          // Si el text parla de foscor o no retorn, posem una icona d'alerta
          const isWarning = item.toLowerCase().includes('no retorn') || item.toLowerCase().includes('foscor');
          
          return (
            <div key={index} className={`timing-item ${isWarning ? 'warning' : ''}`}>
              {isWarning ? <AlertTriangle size={16} /> : <Moon size={16} />}
              <p>{item}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TimingStrategy;